import { Link } from "react-router-dom";
import { FooterCard, Infomation, MobileModal, ViewPager } from "../../component";
import { useAppState, useAppTranslation, useWindowDimensions } from "../../hook";
import { CompanyManagement, ManagementCard, ManagementModal, Milestones, ReferenceCards } from "./constants";
import { Helmet } from "react-helmet-async";
import "./company.page.scss";

export const Company = () => {
    const { t } = useAppTranslation();
    const { width } = useWindowDimensions();
    const [state, setState] = useAppState({
        modalVisible: false,
        managerId: NaN,
    });

    const handleModalVisible = (id: number) => {
        setState((prevState) => ({ ...prevState, modalVisible: !state.modalVisible }));
        if (id) {
            setState((prevState) => ({ ...prevState, managerId: id }));
        }
    };

    const getReferenceCards = () => {
        const cards: React.ReactElement[] = [];

        ReferenceCards.map((card, index) =>
            cards.push(
                <div className="item" key={index}>
                    <img className="icon" src={card.imageUrl} alt="Icon" />

                    <div className="label" dangerouslySetInnerHTML={{ __html: t(card.label) }} />
                </div>
            )
        );
        return cards;
    };

    const getMilestones = () => {
        const cards: React.ReactElement[] = [];

        Milestones.map((card, index) => {
            cards.push(
                <div key={index}>
                    <div className="milestone-container">
                        <div className="year-container">{card.year}</div>
                        <div className="green-circle">
                            {card.last === true && (
                                <img
                                    className="green-line"
                                    src={
                                        width > 866 ? "/image/company_milestones_lineee.svg" : "/image/company_milestones_line_mobileee.svg"
                                    }
                                    alt="Green line"
                                />
                            )}
                        </div>
                        <div className="text-container">{t(card.text)}</div>
                    </div>
                </div>
            );
        });
        return cards;
    };

    const getManagement = () => {
        const cards: React.ReactElement[] = [];

        CompanyManagement.map((card, index) => {
            cards.push(
                <ManagementCard
                    key={index}
                    url={card.imageUrl}
                    title={card.name}
                    description={card.description}
                    setModalVisible={handleModalVisible}
                    id={1 + index}
                />
            );
        });
        return cards;
    };

    return (
        <main className="page page-company">
            <Helmet>
                <title>OTP Multiasset - Company </title>
                <meta name="description" content="OTP Multiasset - Company" />
            </Helmet>
            <div className={`main-div ${state.modalVisible ? "disable-scroll" : ""}`}>
                <div className="description-container">
                    <div className="description-text">
                        <div dangerouslySetInnerHTML={{ __html: t("company_description_text_first") }} />
                        <div>{t("company_description_text_second_paragraph")}</div>
                        <div>{t("company_description_text_third_paragraph")}</div>
                    </div>
                </div>
                <div className="content-card">
                    <div className="title-container">
                        <h2 className="title-text-h1 title">{t("company_shaded_content_title")}</h2>
                        <h3 className="title-text-h2 subtitle">{t("company_shaded_content_first_subtitle")}</h3>
                    </div>
                    <div className="reference-container">
                        {width <= 576 ? (
                            <ViewPager cards={getReferenceCards()} withPadding={true} />
                        ) : (
                            <>{getReferenceCards().map((card) => card)}</>
                        )}
                    </div>
                    <div className="title-container">
                        <h3 className="title-text-h2 subtitle">{t("company_milestones_title")}</h3>
                    </div>
                    <div className="milestone-space-container">{getMilestones().map((card) => card)}</div>
                </div>
                <div className="management-container">
                    <div className="management-title-container">
                        <h2 className="title-text-h1">{t("company_management_title")}</h2>
                    </div>
                    <div className="management-card-container">
                        {width <= 1120 ? <ViewPager cards={getManagement()} /> : <>{getManagement().map((card) => card)}</>}
                    </div>
                </div>
                <div className="afterword-container">
                    <div className="afterword">{t("company_afterword")}</div>

                    <Link to={"https://www.otpbank.hu/otpalapkezelo/hu/fooldal"} target="_blank" rel="noopener noreferrer">
                        <button className="button afterword-button">{t("home_bottom_section_left_title")}</button>
                    </Link>
                </div>
                <Infomation />

                <FooterCard />
            </div>
            {state.modalVisible && width > 576 ? (
                <ManagementModal
                    url={CompanyManagement[state.managerId - 1].imageUrl}
                    title={t(CompanyManagement[state.managerId - 1].name)}
                    description={t(CompanyManagement[state.managerId - 1].description)}
                    postDescription={t(CompanyManagement[state.managerId - 1].postDesctription)}
                    onCloseClick={() => handleModalVisible(NaN)}
                />
            ) : (
                state.modalVisible &&
                width <= 576 && (
                    <MobileModal
                        visible={state.modalVisible}
                        title={t(CompanyManagement[state.managerId - 1].name)}
                        description={t(CompanyManagement[state.managerId - 1].description)}
                        postDescription={t(CompanyManagement[state.managerId - 1].postDesctription)}
                        hideButton={true}
                        onCloseClick={() => handleModalVisible(NaN)}
                    />
                )
            )}
        </main>
    );
};
